export default __webpack_public_path__ + "static/media/blur 4.6504b383.jpg";